export {};  // ensure this file can only be parsed as a module.

const link = document.createElement('link');
link.rel = 'stylesheet';
link.type = 'text/css';
link.crossOrigin = 'anonymous';
link.href =
    'https://fonts.googleapis.com/css?family=Lato:400,300,300italic,400italic,500,500italic,700,700italic';
document.head.appendChild(link);
